import React from 'react';
import { EVENTS_BY_DISCIPLINE } from '../../utils/constants';

const ApparatusSelector = ({ 
  discipline, 
  category, 
  selectedApparatus = [],
  onApparatusChange,
  disabled = false,
  allowMultiple = true
}) => {
  // Obtener los aparatos disponibles para esta disciplina y categoría
  const getAvailableApparatus = () => {
    if (!discipline || !category) return [];
    
    const disciplineEvents = EVENTS_BY_DISCIPLINE[discipline];
    if (!disciplineEvents) return [];
    
    const categoryEvents = disciplineEvents[category];
    if (!categoryEvents) return [];
    
    return categoryEvents;
  };

  
  const availableApparatus = getAvailableApparatus();

  const handleApparatusChange = (apparatusCode) => {
    if (allowMultiple) {
      // Modo múltiple (checkboxes)
      const newSelection = selectedApparatus.includes(apparatusCode)
        ? selectedApparatus.filter(a => a !== apparatusCode)
        : [...selectedApparatus, apparatusCode];
      onApparatusChange(newSelection);
    } else {
      // Modo único (radio)
      onApparatusChange(selectedApparatus === apparatusCode ? '' : apparatusCode);
    }
  };

  if (availableApparatus.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: '20px' }}>
      <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>
        {allowMultiple ? 'Pruebas/Aparatos' : 'Prueba/Aparato'} *
      </label>
      <div style={{
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '15px',
        backgroundColor: '#f9f9f9',
        maxHeight: '300px',
        overflowY: 'auto'
      }}>
        {availableApparatus.length > 0 ? (
          availableApparatus.map(apparatus => (
            <div key={apparatus.code} style={{ marginBottom: '10px' }}>
              {allowMultiple ? (
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={selectedApparatus.includes(apparatus.code)}
                    onChange={() => handleApparatusChange(apparatus.code)}
                    disabled={disabled}
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                  />
                  <span>{apparatus.name}</span>
                </label>
              ) : (
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="apparatus"
                    checked={selectedApparatus === apparatus.code}
                    onChange={() => handleApparatusChange(apparatus.code)}
                    disabled={disabled}
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                  />
                  <span>{apparatus.name}</span>
                </label>
              )}
            </div>
          ))
        ) : (
          <p style={{ color: '#999', margin: 0 }}>
            Selecciona una disciplina y categoría primero
          </p>
        )}
      </div>
    </div>
  );
};

export default ApparatusSelector;
